import { useQuery } from '@tanstack/react-query';

import { fetchClaimTypeList } from '../../data-provider/select-options/claim-type';

export const useGetClaimType = () => {
  return useQuery({
    queryFn: () => fetchClaimTypeList(),
    queryKey: ['over-charge-claim-type-list'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
